import React from "react";

import Grid from "@material-ui/core/Grid";

export default class BannerBuilder {
    static build(cards, pos, userLang) {
        let grids = [];
        let cardno = 0;
        for (let card of cards) {
            const single =
                <Grid
                    item xs={12}
                    key={'gridpos' + pos + 'grid' + cardno + userLang}
                >
                    {card}
                </Grid>;
            grids.push([single, card]);
            cardno++;
        }
        return grids;
    }
}
